import { DISPLAY_NEW_REFERRAL_INTRO_DIALOG } from '../reducers/constants/customPopup';

export const displayReferralIntroDialog = () => {
  return dispatch => {
    dispatch({ type: DISPLAY_NEW_REFERRAL_INTRO_DIALOG });
  };
};
